import React, { useState, useEffect } from 'react';
import InputField from './InputField'; // Adjust the path according to your file structure
import {  useDispatch } from 'react-redux';
import { setUnavailableDates, TimeRange } from '../../redux/eventSlice';
import { mindate , maxdate, getDatesInRange } from '../../utils/util';
interface Field {
  from: string;
  to: string;
  minDate:string;
  maxDate:string;
}


function DynamicTextBox(props:{payloadUnavailableDates:TimeRange[],unavailableDates:TimeRange[],scheduleDays:number}) {

  const {payloadUnavailableDates, unavailableDates, scheduleDays} = props;
  const dispatch = useDispatch();
  const minDate = mindate();

  const maxDate = maxdate(Number(scheduleDays));
  const [fields, setFields] = useState<Field[]>([{ from: '', to: '', minDate:minDate, maxDate:maxDate  }]);

 
  useEffect(() => {
    if(unavailableDates && unavailableDates && unavailableDates.length > 0) {

      const newFields = unavailableDates.map((field:any) => ({ from: field.from, to: field.to,minDate:mindate(),maxDate:maxdate(Number(scheduleDays)) }));
      // console.log(newFields);
      setFields(newFields);
      const filteredArray = newFields
      .map(({ from, to }) => ({ from, to }));
      dispatch(setUnavailableDates(filteredArray));

    }
  },[unavailableDates]);
 
  useEffect(() => {
    if(payloadUnavailableDates && payloadUnavailableDates.length > 0) {
      // console.log(payloadUnavailableDates);
      const newFields = payloadUnavailableDates.map((field:any) => ({ from: field.from, to: field.to,minDate:mindate(),maxDate:maxdate(Number(scheduleDays)) }));
      // console.log(newFields);
      //  setFields(newFields);
    }
  },[payloadUnavailableDates]);

  const addField = () => {
    const newFields = [...fields, { from: '', to: '',minDate:minDate,maxDate:maxDate }];
    setFields(newFields);
  };

  const removeField = () => {
    if (fields.length > 1) {
      const newFields = fields.slice(0, -1);
      setFields(newFields);
      const filteredArray = newFields
      .map(({ from, to }) => ({ from, to }));
      dispatch(setUnavailableDates(filteredArray));
    }
  };

  const handleTimeChange = (index:number, type:string, value:string) => {
    // console.log(index,type,value);
  
    const updatedFields = fields.map((field, idx) => {
     //  console.log(field,idx,index);
      if (idx === index) {
        return { ...field, [type]: value };
      }
      return field;
    });
   //  console.log(updatedFields);
    setFields(updatedFields);
    const filteredArray = updatedFields
    .filter(field => field.from !== '' && field.to !== '')
    .map(({ from, to }) => ({ from, to }));
    // console.log(filteredArray,'_filteredArray');
    dispatch(setUnavailableDates(filteredArray));
      /*
    */
  // console.log(updatedFields,'__updatedFields_____');
    // setFields(updatedFields);

    /*
    const filteredArray = fields
    .filter(field => field.from !== '' && field.to !== '')
    .map(({ from, to }) => ({ from, to }));
    */
   // dispatch(setUnavailableDates(filteredArray));
  };
  // console.log('__fields_____fields___',fields);

  return (
    <div>
      {fields.map((field, index) => (
        <div key={index} className="mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
          <InputField
            extra="mb-3"
            label="Non Working Dates (from)"
            placeholder="dd:mm:yyyy"
            id={`address-from-${index}`}
            type="date"
            minDate={field.minDate}
            value={field.from}
            maxDate={field.maxDate}
            onChange={(e:any) => handleTimeChange(index, 'from', e.target.value)}
            />
        <InputField
          extra="mb-3"
          label="Non Working Dates (to)"
          placeholder="dd:mm:yyyy"
          id={`address-to-${index}`}
          type="date"
          minDate={field.from}
          value={field.to}
          maxDate={field.maxDate}
          onChange={(e:any) => handleTimeChange(index, 'to', e.target.value)}
          />
          {/* Add more InputField components as needed */}
        </div>
      ))}

      <button onClick={addField} className="mt-4 px-4 py-2 rounded bg-blue-500 text-white">+</button>
      <button onClick={removeField} className="mt-4 ml-2 px-4 py-2 rounded bg-red-500 text-white">-</button>
    </div>
  );
}

export default DynamicTextBox;
